import { sumBy } from 'lodash-es';
import type {
  IAcceptOrderItemPayload,
  IRedistributionPricingResult,
  ISuggestedOffer,
} from '~/purchase/types';

export function calculatePricing(
  suggestedOffers: Array<ISuggestedOffer>,
  watchedItems: Array<IAcceptOrderItemPayload>,
): IRedistributionPricingResult {
  const buyingTotalExclTaxProduct = sumBy(
    suggestedOffers,
    (suggestedOffer) =>
      (suggestedOffer.offer.redistributionBuyingPrice ?? 0) *
      (watchedItems.find((item) => item.lineId === suggestedOffer.offerId)
        ?.quantity ?? 0),
  );
  const sellingTotalExclTaxProduct = sumBy(
    suggestedOffers,
    (suggestedOffer) =>
      (watchedItems.find((item) => item.lineId === suggestedOffer.offerId)
        ?.sellingPrice ?? 0) *
      (watchedItems.find((item) => item.lineId === suggestedOffer.offerId)
        ?.quantity ?? 0),
  );
  let buyingTotalExclTaxDelivery = 0;
  let sellingTotalExclTaxDelivery = 0;
  watchedItems.forEach((item, itemIndex) => {
    const suggestedOffer = suggestedOffers.at(itemIndex);
    if (suggestedOffer?.offer.deliveryFeesEligible && item.quantity === 1) {
      buyingTotalExclTaxDelivery =
        buyingTotalExclTaxDelivery +
        (suggestedOffer.delivery?.buyingPrice?.base ?? 0);
      sellingTotalExclTaxDelivery =
        sellingTotalExclTaxDelivery +
        (suggestedOffer.delivery?.sellingPrice?.base ?? 0);
    }
  });

  const ecoTax = sumBy(
    suggestedOffers,
    (suggestedOffer) =>
      (suggestedOffer.offer.recyclingFee ?? 0) *
      (watchedItems.find((item) => item.lineId === suggestedOffer.offerId)
        ?.quantity ?? 0),
  );
  const buyingTotalExclTax =
    buyingTotalExclTaxProduct + buyingTotalExclTaxDelivery + ecoTax;
  const sellingTotalExclTax =
    sellingTotalExclTaxProduct + sellingTotalExclTaxDelivery + ecoTax;

  const buyingTaxAmount = sumBy(
    suggestedOffers,
    (suggestedOffer) =>
      ((suggestedOffer.offer.recyclingFee ?? 0) +
        (suggestedOffer.offer.redistributionBuyingPrice ?? 0)) *
      ((suggestedOffer.offer.vatPercentage ?? 0) / 100) *
      (watchedItems.find((item) => item.lineId === suggestedOffer.offerId)
        ?.quantity ?? 0),
  );
  const sellingTaxAmount = sumBy(
    suggestedOffers,
    (suggestedOffer) =>
      ((suggestedOffer.offer.recyclingFee ?? 0) +
        (suggestedOffer.offer.redistributionSellingPrice ?? 0)) *
      ((suggestedOffer.offer.vatPercentage ?? 0) / 100) *
      (watchedItems.find((item) => item.lineId === suggestedOffer.offerId)
        ?.quantity ?? 0),
  );
  const buyingTotalInclTax = buyingTotalExclTax + buyingTaxAmount;
  const sellingTotalInclTax = sellingTotalExclTax + sellingTaxAmount;

  return {
    buyingTotalExclTaxProduct,
    sellingTotalExclTaxProduct,
    buyingTotalExclTaxDelivery,
    sellingTotalExclTaxDelivery,
    buyingTaxAmount,
    sellingTaxAmount,
    buyingTotalExclTax,
    sellingTotalExclTax,
    buyingTotalInclTax,
    sellingTotalInclTax,
    ecoTax,
  };
}
